import { render } from "./SlotForm.vue?vue&type=template&id=3f09dd06&scoped=true&ts=true"
import script from "./SlotForm.vue?vue&type=script&lang=ts"
export * from "./SlotForm.vue?vue&type=script&lang=ts"

import "./SlotForm.vue?vue&type=style&index=0&id=3f09dd06&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f09dd06"]])

export default __exports__